export default "__VITE_PUBLIC_ASSET__a843fa90__"